document.addEventListener('jquery:ready', function () {
  var $items = $('.custom-social-proof');
  var len = $items.length;
  if (!len || typeof spInterval === 'undefined') return;

  var names = window.spNames || [];
  var countries = window.spCountryList || [];

  setInterval(function () {
    var randomMinutes = Math.floor(Math.random() * 57) + 2;
    var random = Math.floor(Math.random() * len);
    var $shown = $items.eq(random);
    $('.social-proof-popup').show();
    $items.removeClass('show');
    $shown.stop().addClass('show');
    if (window.spShowName && names.length) {
      $shown.find('.customer-name').text(names[Math.floor(Math.random() * names.length)]);
    }
    if (countries.length) {
      $shown.find('.minutes-passed').text(
        randomMinutes + ' minutes ago from ' + countries[Math.floor(Math.random() * countries.length)]
      );
    }
  }, spInterval);

  var showStatusStorage = sessionStorage;
  if (!showStatusStorage.getItem('showStatus')) {
    showStatusStorage.setItem('showStatus', 'ShowSocialProof');
  }
  if (showStatusStorage.getItem('showStatus') === 'ShowSocialProof') {
    $('.social-proof-popup').removeClass('hide');
  }
  if (showStatusStorage.getItem('showStatus') === 'dontShowSocialProof') {
    $('.social-proof-popup').addClass('hide');
  }

  $('.social-proof-close').on('click', function () {
    $(this).closest('.social-proof-popup').addClass('hide');
    $('.custom-social-proof').removeClass('show');
    if ($('#dont-show-again').is(':checked')) {
      showStatusStorage.setItem('showStatus', 'dontShowSocialProof');
    }
  });
});
